import axios from 'axios';

/**
 * Service to handle synchronization operations with Tango ERP.
 * Communicates with the backend REST endpoints.
 */
class TangoSyncService {
  /**
   * Triggers manual synchronization for products, stock, and price lists.
   * @returns {Promise<Object>} The API response data.
   */
  async syncProducts() {
    const response = await axios.post('/api/integrations/sync/products/');
    return response.data;
  }

  /**
   * Triggers manual synchronization for clients.
   * @returns {Promise<Object>} The API response data.
   */
  async syncClients() {
    const response = await axios.post('/api/integrations/sync/clients/');
    return response.data;
  }
}

export default new TangoSyncService();
